import axios from "../../../../helper/axios";
import * as actionTypes from "../../actionTypes";

export const SelectProjectId = (projectId) => {
  return {
    type: actionTypes.SELECT_PROJECT_ID,
    projectId: projectId,
  };
};
export const clearProjectId = () => {
  return {
    type: actionTypes.CLEAR_PROJECT_ID,
  };
};

export const fetchClientProjectPeriodStart = () => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECT_PERIOD_START,
  };
};

export const fetchClientProjectPeriodSuccess = (data) => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECT_PERIOD_SUCCESS,
    data,
  };
};

export const fetchClientProjectPeriodFail = (error) => {
  return {
    type: actionTypes.FETCH_CLIENT_PROJECT_PERIOD_FAIL,
    error,
  };
};

export const fetchClientProjectPeriod = (projectId) => {
  return (dispatch) => {
    dispatch(fetchClientProjectPeriodStart());
    axios
      .get(`admin/client/period/${projectId}`)
      .then((res) => {
        // console.log(res);
        dispatch(fetchClientProjectPeriodSuccess(res.data));
      })
      .catch((error) => {
        console.log(error);
        console.log(error.response);
        if (error.response) {
          dispatch(fetchClientProjectPeriodFail(error.response.data.message));
        } else {
          dispatch(fetchClientProjectPeriodFail("Something went wrong"));
        }
      });
  };
};

////////create traker//////
export const createClientProjectPeriodStart = () => {
  return {
    type: actionTypes.CREATE_CLIENT_PROJECT_PERIOD_START,
  };
};

export const createClientProjectPeriodSuccess = (newPeriod, msg) => {
  return {
    type: actionTypes.CREATE_CLIENT_PROJECT_PERIOD_SUCCESS,
    newPeriod,
    msg,
  };
};

export const createClientProjectPeriodFail = (error) => {
  return {
    type: actionTypes.CREATE_CLIENT_PROJECT_PERIOD_FAIL,
    error,
  };
};

export const createClientProjectPeriod = (projectId, data, callBack) => {
  return (dispatch) => {
    console.log(projectId);
    dispatch(createClientProjectPeriodStart());
    axios
      .post(`admin/client/period/${projectId}`, data)
      .then((res) => {
        // console.log(res);
        dispatch(createClientProjectPeriodSuccess(res.data, res.data.message));
        callBack();
      })
      .catch((err) => {
        // console.log(err);
        // console.log(err.response);
        if (err.response) {
          dispatch(createClientProjectPeriodFail(err.response.data.message));
        } else {
          dispatch(createClientProjectPeriodFail("Something went wrong"));
        }
      });
  };
};
